import { useThemeStore } from '@/app/providers/themeStore';
import { light, dark } from './tokens';

/**
 * Returns the full semantic color palette for the current theme mode.
 * Replaces every per-page `const colors = { bg, border, text, ... }` object.
 *
 * Usage:
 *   const c = useThemeColors();
 *   <div style={{ background: c.bg, color: c.textPrimary }}>
 */
export function useThemeColors() {
  const { effectiveMode } = useThemeStore();
  return effectiveMode === 'dark' ? dark : light;
}

/**
 * Returns just the isDark boolean. Convenience hook when you only need
 * conditional logic without the full color object.
 */
export function useIsDark() {
  const { effectiveMode } = useThemeStore();
  return effectiveMode === 'dark';
}
